import { SimilarByPatternSettingsReducerState } from '../app-state-types';
import { SimilarByPatternSettingsAction, SimilarByPatternActionTypes } from '../components-bl';

const initialState: SimilarByPatternSettingsReducerState = {
  numberOfResultsToDisplay: 12,
  shouldRefetch: false,
};

export function similarByPatternSettingsReducer(
  state: SimilarByPatternSettingsReducerState = initialState,
  action?: SimilarByPatternSettingsAction
): SimilarByPatternSettingsReducerState {
  switch (action?.type) {
    case SimilarByPatternActionTypes.GetSimilarByPatternSettingsSuccess: {
      const { numberOfResultsToDisplay } = action.payload;
      return {
        ...state,
        numberOfResultsToDisplay,
        shouldRefetch: false,
      };
    }
    case SimilarByPatternActionTypes.GetSimilarByPatternSettingsRequest:
      return { ...state };
    case SimilarByPatternActionTypes.GetSimilarByPatternSettingsError:
      return { ...state };
    case SimilarByPatternActionTypes.UpdateSimilarByPatternSettingsSuccess: {
      const { numberOfResultsToDisplay } = action.payload;

      return {
        ...state,
        numberOfResultsToDisplay,
      };
    }
    default:
      return state;
  }
}
